module.exports = __webpack_public_path__ + "static/img/lres2.020a7da.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/lres2.png
// module id = Bpgo
// module chunks = 1